import React from 'react';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';
import { styled } from '@tmap/mmm-style-guide/src/styled';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';
import { Field } from '@tmap/mmm-style-guide/src/final-form/react';
import miniHandlebars from '@tmap/mmm-core/miniHandlebars';
import configToProps from './configToProps';

const PaddedTypography = styled(Typography, {
  shouldForwardProp: (p) => p !== 'titleSpacing',
})(({ titleSpacing }) => ({
  marginTop: {
    center: 0,
    small: '8px',
    medium: '16px',
  }[titleSpacing],
}));

function Question(props) {
  const {
    field,
    data = {},
    defaults,
    titleSpacing = 'center',
    titleProps = {},
  } = props;
  if (!field) return null;
  if (field.type === 'checkbox') {
    return (
      <Grid item xs={12}>
        <Field
          {...configToProps(field, { config: field, ...data }, defaults)}
        />
      </Grid>
    );
  }

  return (
    <Grid item xs={12}>
      <Grid container spacing={1.5} alignItems={titleSpacing === 'center' ? 'center' : 'start'} sx={{ flexDirection: { xs: 'column', md: 'row' } }}>
        <Grid item width={{ xs: '100%' }} md={5}>
          <PaddedTypography variant='body2' {...titleProps} titleSpacing={titleSpacing}>
            {miniHandlebars(field.label, { config: field, ...data })}
          </PaddedTypography>
          {!field.required && (
            <Typography variant='body2' color='text.disabled' fontStyle='italic'>
              Optional
            </Typography>
          )}
        </Grid>
        <Grid item width={{ xs: '100%' }} md={7}>
          <Field
            {...configToProps({
              ...field,
              label: field.name,
            }, {
              config: field,
              ...data,
            }, defaults)}
            variant='outlined'
          />
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Question;
